module.exports = __webpack_public_path__ + "img/upload_icon.f773dbb1.svg";